class MegaMenuCollectionPanels extends HTMLElement {
  constructor() {
    super();
    this.triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
    this.details = this.closest('details');

    if (!this.triggers.length || !this.panels.length) return;

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onDetailsToggle = this.onDetailsToggle.bind(this);
  }

  connectedCallback() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.onTriggerClick);
    });

    if (this.details) {
      this.details.addEventListener('toggle', this.onDetailsToggle);
    }
  }

  disconnectedCallback() {
    this.triggers.forEach((trigger) => {
      trigger.removeEventListener('click', this.onTriggerClick);
    });

    if (this.details) {
      this.details.removeEventListener('toggle', this.onDetailsToggle);
    }
  }

  onTriggerClick(event) {
    const trigger = event.currentTarget;
    const targetId = trigger.dataset.panelTarget;

    if (!targetId) return;

    this.setActivePanel(targetId);
  }

  onDetailsToggle() {
    if (this.details && !this.details.hasAttribute('open')) {
      this.reset();
    }
  }

  setActivePanel(targetId) {
    this.triggers.forEach((trigger) => {
      const isActive = trigger.dataset.panelTarget === targetId;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panelId === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });

    const activePanel = this.panels.find((panel) => panel.dataset.panelId === targetId);

    if (!activePanel) return;

    requestAnimationFrame(() => {
      this.classList.add('is-detail-open');
      activePanel.focus();
    });
  }

  reset() {
    this.classList.remove('is-detail-open');

    this.triggers.forEach((trigger) => {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    });
  }
}

customElements.define('mega-menu-collection-panels', MegaMenuCollectionPanels);
